import {Radio} from 'antd'

// Box-style tab bar used across the Promote Changes modals (Delete Files,
// Select Files, Preview / Promoted Files). Styled to match the theme's
// box tabs (Administration, plugins): bordered items with visible separators
// and a solid selected fill. See .promote-box-tabs in _promote_changes.scss.
const BoxTabs = ({ options = [], value = '', onChange = () => {} }) => (
  <Radio.Group
    className="promote-box-tabs"
    options={options}
    value={value}
    onChange={onChange}
    optionType="button"
    buttonStyle="outline"
  />
)

export default BoxTabs
